export default __webpack_public_path__ + "images/avatars.b75501e69f4cc2b8de06.png";